import { memo, useCallback, useMemo } from "react";
import { BottomNavigationAction } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { BOTTOM_NAV_ITEMS } from "@/components/layout/MobileLayout/MobileBottomNav.constants";
import { BottomNavWrapper, StyledBottomNav } from "@/components/layout/MobileLayout/mobile-layout.styles";
import { useTrialStatus } from "@/hooks/useTrialStatus";
import { AppRoutes } from "@/routes/config";

const TRIAL_DISABLED_ROUTES: string[] = [AppRoutes.vocabularyCategoryList, AppRoutes.mockExam];

const isPathMatch = (itemPath: string, currentPath: string): boolean => {
  if (itemPath === "/") {
    return currentPath === "/";
  }
  return currentPath === itemPath || currentPath.startsWith(itemPath + "/");
};

const MobileBottomNavComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isTrial } = useTrialStatus();

  const currentIndex = useMemo(() => {
    return BOTTOM_NAV_ITEMS.findIndex((item) => isPathMatch(item.path, location.pathname));
  }, [location.pathname]);

  const handleChange = useCallback(
    (_: React.SyntheticEvent, newValue: number) => {
      const item = BOTTOM_NAV_ITEMS[newValue];
      if (!item) return;
      if (isTrial && TRIAL_DISABLED_ROUTES.includes(item.path)) return;
      if (item.path === location.pathname) return;
      navigate(item.path);
    },
    [navigate, isTrial, location.pathname],
  );

  return (
    <BottomNavWrapper>
      <StyledBottomNav value={currentIndex >= 0 ? currentIndex : 0} onChange={handleChange} showLabels>
        {BOTTOM_NAV_ITEMS.map((item) => {
          const isDisabled = isTrial && TRIAL_DISABLED_ROUTES.includes(item.path);
          return (
            <BottomNavigationAction
              key={item.path}
              label={item.label}
              icon={<item.icon />}
              disabled={isDisabled}
              sx={isDisabled ? { opacity: 0.4 } : undefined}
            />
          );
        })}
      </StyledBottomNav>
    </BottomNavWrapper>
  );
};

export const MobileBottomNav = memo(MobileBottomNavComponent);
